import { render, staticRenderFns } from "./HonorDetail.vue?vue&type=template&id=2a1d3428&scoped=true"
import script from "./HonorDetail.vue?vue&type=script&lang=js"
export * from "./HonorDetail.vue?vue&type=script&lang=js"
import style0 from "./HonorDetail.vue?vue&type=style&index=0&id=2a1d3428&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1d3428",
  null
  
)

export default component.exports